import DBFileBrowser from "framework/components/DBFileBrowser"
import DPImage from "framework/components/DPImage"

import React, { useEffect, useState } from "react"
import { CardText, Col, Label, Row, Alert, Button } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"

import DPDropDown from "framework/components/DPDropDown"
import DPSwitch from "framework/components/DPSwitch"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import imageExcelUpload from "../../../assets/images/Upload.png"
import imageExcelDownload from "../../../assets/images/Download.png"
import MasterUpload from "../../../assets/File/SalesExecutive.xlsx";
import DPImagePop from 'framework/components/DPImagePop'
import { loadPopupSearchPay } from "framework/validators/SearchColumn"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
// const photovalues ={
//   imageSrc:NoiMage,
//   imageFile:null 
// }


const SalesExecutiveMasterTab1 = ({
  code,
  codeonChange,
  findCode,
  title,
  titleonChange,
  fname,
  fnameonChange,
  lname,
  lnameonChange,
  fulname,
  fulnameonChange,
  gcode,
  gcodeonChange,
  refcode,
  refcodeonChange,
  idnum,
  idnumonChange,
  GlRef,
  GlRefonChange,
  SwonChange,
  ActiveSw,
  reglocation,
  reglocationonChange,
  gender,
  genderstate,
  genderonChange,
  jobdesig,
  jobdesigonChange,
  AlertColor,
  AlertMsg,
  show,
  disabledCode,
  disabled,
  ShowPreview,
  imagesrc,
  salesDataSearch,
  ErrorMsg,
  lnameonblur,
  fnameonblur,
  fileimage,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,
  executive_SelectRowSearch, // Selected row of the Search window
  executive_CodeSearchTrigger, // Calls when search window is required to be poped up
  executive_CodeSearchOpen, // Open status of the Search window
  showFileUpload,
  valueUpload,
  menuCode,
  autoCode,
  RemoveImage,
  setJoinDate,
  setResignDate,
  resignDate,
  joinDate
}) => {



  const [isOpen, SetIsOpen] = useState(false)
  const showPop = () => {
    SetIsOpen(!isOpen)
  }

  // const[values,setValues] = useState(photovalues)
  const [titleGroup, SetTitleGroup] = useState([])
  const [DataGroup, setDataGroup] = useState([]);
  const [locationGroup, setlocationGroup] = useState([]);
  const [AssistGroup, setAssistGroup] = useState([]);

  const Gender = [{ value: "M", label: "Male" }, { value: "F", label: "Female" }, { value: "U", label: "Unassigned" }];
  //const Title =[{value:"001",label:"Mr"},{value:"002",label:"Ms"},{value:"003",label:"Mrs"}] 

  //  api call to job designation

  const [HeadColumns, setHeadColumns] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL


  useEffect(async () => {
    setHeadColumns(await loadPopupSearchPay(menuCode, 'SALEEXE'))
  }, [menuCode]);
  //*** End of useStates */


  useEffect(() => {
    const authToken = localStorage.getItem("authToken")
    function getDesignation() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Designation/Select/`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setDataGroup(result.data)
          // let dt = result.data
          // console.log(dt)
        }).catch(error => console.log('error', error));

    }
    function getTitle() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Title/Select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetTitleGroup(result.data)
          //  let dt = result.data
          // console.log(dt)


        }).catch(error => console.log('error', error));

    }
    function getSalesAssistantGroup() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}SalesAssistantGroup/Select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setAssistGroup(result.data)
          // let dt = result.data
          // console.log(dt)


        }).catch(error => console.log('error', error));
    }
    function getLocations() {
      var requestOptions = {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${authToken}`
        },
        redirect: 'follow'
      };
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Locations/select`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setlocationGroup(result.data)
          // let dt = result.data
          // console.log(dt)

        })
        .catch(error => console.log('error', error));
    }
    getLocations()
    getSalesAssistantGroup()
    getTitle()
    getDesignation()
  }, []);

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                    <br />
                    <small>{ErrorMsg}</small>
                  </Alert>
                ) : null}
                <Col sm={12} md={6} className="mb-4-sm">
                  <Row>
                    <Col>
                      <DPTextBoxButton
                        rowClass="mb-4-sm"
                        labelText="Code *"
                        textType="text"
                        maxLength="10"
                        value={code}
                        onChange={codeonChange}
                        onBlur={findCode}
                        disabled={disabled == true ? disabled : disabledCode}
                        onButtonClick={onButtonClick}
                        btnDisable={disabled == true ? disabled : btnDisable}
                        placeholder={autoCode}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm">
                      <Button
                        onClick={salesDataSearch}
                        color="success"
                        className="btn-sm"
                        disabled={SearchDisable}
                      >
                        <i
                          className="mdi mdi-search-web"
                          style={{ fontSize: "12px" }}
                        ></i>
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPDropDown
                        labelText="Title *"
                        rowClass="mb-4-sm"
                        optionGroup={titleGroup}
                        selectedGroup={title}
                        onChange={titleonChange}
                        disabled={disabled}
                      />

                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="First Name *"
                        textType="text"
                        maxLength="40"
                        value={fname}
                        onChange={fnameonChange}
                        onBlur={fnameonblur}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Last Name"
                        textType="text"
                        maxLength="40"
                        value={lname}
                        onChange={lnameonChange}
                        onBlur={lnameonblur}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Full Name"
                        textType="text"
                        maxLength="100"
                        value={fulname}
                        onChange={fulnameonChange}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPDropDown
                        labelText="Sales Executive Group *"
                        rowClass="mb-4-sm"
                        optionGroup={AssistGroup}
                        selectedGroup={gcode}
                        onChange={gcodeonChange}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Reference Code"
                        textType="Text"
                        maxLength="30"
                        value={refcode}
                        onChange={refcodeonChange}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="National ID Number *"
                        textType="text"
                        maxLength="12"
                        value={idnum}
                        onChange={idnumonChange}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="GL Reference Code"
                        textType="text"
                        maxLength="30"
                        value={GlRef}
                        onChange={GlRefonChange}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Join Date"
                        textType="date"
                        maxLength="30"
                        value={joinDate}
                        onChange={setJoinDate}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Resign Date"
                        textType="date"
                        maxLength="30"
                        value={resignDate}
                        onChange={setResignDate}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={12} md={1} className="mb-4-sm"></Col>
                  </Row>
                  <Row>
                    <Col>
                      {/* status switch */}
                      <p></p>
                      <Row>
                        <Col sm={3}>
                          <Label
                            htmlFor="example-text-input"
                            className={`col-md-12 col-form-label-sm`}
                          >
                            Status
                          </Label>
                        </Col>
                        <Col >
                          <DPSwitch
                            rowClass={"mb-4-sm"}
                            onChange={SwonChange}
                            checked={ActiveSw}
                            disabled={disabled}
                          />           </Col>
                        <Col sm={12} md={1} className="mb-4-sm"></Col>
                      </Row>

                    </Col>
                  </Row>
                </Col>
                <Col>

                  <DPDropDown
                    labelText="Registered Location *"
                    rowClass="mb-4-sm"
                    optionGroup={locationGroup}
                    selectedGroup={reglocation}
                    onChange={reglocationonChange}
                    disabled={disabled}
                  />

                  {/* image upload    */}

                  <Row className="mb-4-sm">
                    <Label
                      htmlFor="example-text-input"
                      className="col-md-3 col-form-label-sm" >
                      Image Upload
                    </Label>
                    <div className="col-md-9">
                      <div>
                        <Row>
                          <Col sm="12">
                            <CardText className="mb-0">
                              <Row>
                                <Col sm={12} md={12} className="mb-4-sm">
                                  <DPImage
                                    labelText={imagesrc}
                                    onClick={showPop}
                                    style={{ cursor: 'pointer' }}
                                  ></DPImage>
                                  <DPImagePop
                                    toggle={showPop}
                                    isOpen={isOpen}
                                    ImgSrc={imagesrc}
                                  />
                                  <DBFileBrowser
                                    accept="image/*"
                                    rowClass="mb-4-sm"
                                    showPrewiew={ShowPreview}
                                    disable={disabled}
                                    value={fileimage}
                                  ></DBFileBrowser>
                                </Col>
                              </Row>
                              <Row className="mt-1">
                                <Col sm={12} md={6} className="mb-4-sm">
                                  <Button
                                    color="danger"
                                    className="mr-1"
                                    disabled={disabled}
                                    onClick={RemoveImage}
                                    size="sm"
                                  >
                                    Remove Image
                                  </Button>
                                </Col>
                              </Row>
                            </CardText>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Row>

                  <p></p>

                  <DPDropDown
                    labelText="Gender"
                    rowClass="mb-4-sm"
                    optionGroup={Gender}
                    selectedGroup={gender}
                    onChange={genderonChange}
                    disabled={disabled == true ? disabled : genderstate}
                  />

                  <DPDropDown
                    labelText="Job Designation"
                    rowClass="mb-4-sm"
                    optionGroup={DataGroup}
                    selectedGroup={jobdesig}
                    onChange={jobdesigonChange}
                    disabled={disabled}
                  />

                </Col>
                <Col sm={12} md={2} className="mb-4-sm">
                  <ul className="import-export-button-block" style={{ display: "flex", flexFlow: "row", flexWrap: "wrap", padding: "0px", justifyContent: "end" }}>
                    <li className="import-export-button" style={{ display: "block" }}>
                      <input
                        id="file"
                        type="file"
                        onChange={showFileUpload}
                        value={valueUpload}
                        disabled={disabledCode}
                        accept=".xlsx, .xls, .csv"
                        style={{ display: "none" }}
                      />

                      <label htmlFor="file" title="Master Excel Upload" style={{ cursor: "pointer", opacity: disabledCode == true ? "0.5" : "1" }}>
                        <span >
                          <img class="manImg" src={imageExcelUpload} style={{ width: "40px", height: "40px" }}></img>
                        </span>
                      </label></li>

                    <li className="import-export-button" style={{ display: "block" }}>
                      <a href={MasterUpload} download="Master File Upload" data-tip title="Master excel format download"
                        style={{ pointerEvents: disabledCode ? 'none' : '', }} >
                        <img class="manImg" src={imageExcelDownload} style={{ width: "40px", height: "40px", opacity: disabledCode == true ? "0.5" : "1" }}></img>
                      </a></li>
                  </ul>
                </Col>
              </Row>
            </CardText>
          </Col>

          <DPSearchBoxDynamic
            searchData={[]}
            columns={HeadColumns}
            defaultSorted={defaultSorted}
            mainTitle={menuName + " Search"}
            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={executive_CodeSearchOpen}
            toggle={executive_CodeSearchTrigger}
            getSelect={executive_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"SALEEXE"}
            MenuCode={menuCode}
            KeyVal={"EXE"}
            searchBy={"SA_CODE"}
            FilterStr={groupFilter}
          />

        </Row>
      </div>
    </React.Fragment>
  )
}
export default SalesExecutiveMasterTab1
